/** Looks up the latest published CLI version from the npm registry (dist-tags). */
import { PACKAGE_NAME } from '../version.js'

const DEFAULT_REGISTRY = 'https://registry.npmjs.org'

/** The registry base URL, overridable for private mirrors (e.g. VERENTIS_UPDATE_REGISTRY). */
export function registryUrl(): string {
  const configured = process.env.VERENTIS_UPDATE_REGISTRY ?? process.env.npm_config_registry ?? DEFAULT_REGISTRY
  return configured.replace(/\/+$/, '')
}

/**
 * Fetches the `latest` dist-tag for the CLI package. Returns null on any failure (offline, timeout,
 * 4xx/5xx, malformed body) so callers can degrade gracefully — this is only ever a hint.
 */
export async function fetchLatestVersion(options: { timeoutMs?: number } = {}): Promise<string | null> {
  const url = `${registryUrl()}/${PACKAGE_NAME.replace('/', '%2F')}`
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), options.timeoutMs ?? 3000)
  try {
    const res = await fetch(url, {
      // The abbreviated packument is far smaller than the full manifest but still carries dist-tags.
      headers: { Accept: 'application/vnd.npm.install-v1+json' },
      signal: controller.signal,
    })
    if (!res.ok) return null
    const body = (await res.json()) as { 'dist-tags'?: Record<string, string> }
    return body['dist-tags']?.latest ?? null
  } catch {
    return null
  } finally {
    clearTimeout(timer)
  }
}
